import React from "react";
import { Button } from 'primereact/button';

export default function CourseLevelItem({courseItem}) {

    return (
        <div key={courseItem.id} className="course-level-item">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14rem"
                height="7.625rem"
                viewBox="0 0 225 122"
                fill="none"
                style={{ position: 'absolute', top: 0, left: 0 }}
            >
                <g filter="url(#filter0_dd_4077_22636)">
                <path
                    d="M12.4157 26.0909C7.29616 15.7354 4.73638 10.5577 7.0836 6.77883C9.43083 3 15.2068 3 26.7586 3H169.603C173.399 3 175.297 3 176.945 3.79594C178.594 4.59187 179.774 6.07816 182.134 9.05073L213.1 48.0507C216.89 52.8237 218.785 55.2102 218.785 58C218.785 60.7898 216.89 63.1763 213.1 67.9493L182.134 106.949C179.774 109.922 178.594 111.408 176.945 112.204C175.297 113 173.399 113 169.603 113H26.7586C15.2068 113 9.43083 113 7.0836 109.221C4.73638 105.442 7.29616 100.265 12.4157 89.9091L24.6854 65.0909C26.4063 61.61 27.2667 59.8695 27.2667 58C27.2667 56.1305 26.4063 54.39 24.6854 50.9091L12.4157 26.0909Z"
                    fill="#F8FAFC"
                />
                </g>
                <defs>
                <filter
                    id="filter0_dd_4077_22636"
                    x="0.206291"
                    y="0"
                    width="224.579"
                    height="122"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4077_22636" />
                    <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                    />
                    <feBlend mode="normal" in2="effect1_dropShadow_4077_22636" result="effect2_dropShadow_4077_22636" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4077_22636" result="shape" />
                </filter>
                </defs>
            </svg>

            <div className="course-level-item-content">
                <h2 className="text-base font-weight-900 my-1">{courseItem.title}</h2>
                <h2 className="text-sm font-weight-400 my-1">{courseItem.description}</h2>
                <Button className="text-sm font-weight-400" label={courseItem.buttonLabel} severity="info" />                
            </div>
        </div>
    );
}